export default {
  LOGIN: "登陆",
  SIGNUP: "注册",
  FORGOT_PASSWORD: "忘记密码？",
  OR_LOGIN_WITH_EMAIL: "或者您可以使用",
  LOGIN_WITH: "使用",
  OR_SIGNUP_WITH_EMAIL: "或者您可以使用电子邮件注册",
  EMAIL_FOR_RESET_PASSWORD: "请登陆您的邮箱验证。",
  AUTHENTICATION_TYPE_SUBTITLE: "选择用户注册和登录时使用的标识符。"
};
